export default {
  header: {
    home: 'Home',
    translateName: 'Translate',
    customName: 'Custom',
    multilingualName: 'Multilingual',
    knowledgeBase: 'Knowledge',
    login: 'Login',
    signup: 'Sign Up',
    siteName: 'ChineseName.us',
    aboutUs: 'About'
  },
  footer: {
    aboutUs: 'About Us',
    contact: 'Contact',
    privacy: 'Privacy Policy',
    terms: 'Terms of Service',
    copyright: '© 2026 ChineseName.us. All rights reserved.',
    friendlyLinks: 'Friendly Links'
  },
  home: {
    hero: {
      title: 'Professional Chinese Name Service',
      subtitle: 'Chinese name customization platform based on traditional culture and modern technology',
      cta: 'Translate My Name Now'
    },
    features: {
      title: 'Language Tool Services',
      nameToPinyin: {
        title: 'Name to Pinyin',
        description: 'Convert Chinese names to accurate pinyin with tone marks and pronunciation guidance'
      },
      pinyinToName: {
        title: 'Pinyin to Characters',
        description: 'Find suitable Chinese characters based on pinyin to help you choose the ideal Chinese name'
      },
      characterStrokes: {
        title: 'Chinese Character Stroke Order',
        subtitle: 'View stroke order and pronunciation of Chinese characters, learn the correct writing method',
        inputTitle: 'Enter a Character to Search',
        inputPlaceholder: 'Enter a character',
        inputHint: 'Please enter a Chinese character, e.g.: 爱, 德, 福',
        popularCharacters: 'Common Characters',
        loading: 'Retrieving character information...',
        pinyin: 'Pinyin',
        strokeCount: 'Stroke Count',
        radical: 'Radical',
        meaning: 'Meaning',
        strokeOrder: 'Stroke Order',
        demoAnimation: 'Animation Demo',
        strokeDetails: 'Stroke Details',
        basicStrokes: 'Basic Strokes',
        strokeSequence: 'Character Stroke Sequence',
        noSequenceData: 'No detailed stroke sequence data available',
        relatedCharacters: 'Related Characters',
        noRelatedData: 'No related character data available',
        errorTitle: 'Search Error',
        noData: 'No data available'
      },
      namingService: {
        title: 'Personalized Naming Services',
        custom: {
          title: 'Custom Chinese Name',
          description: 'Tailor-made Chinese names based on your preferences, personal traits and cultural background'
        },
        zodiac: {
          title: 'Zodiac Calculator',
          description: 'Calculate your Chinese zodiac sign and learn about its characteristics and naming suggestions'
        },
        constellation: {
          title: 'Constellation Analysis',
          description: 'Analyze your constellation traits based on your birth date, providing detailed interpretation and naming suggestions'
        },
        numerology: {
          title: 'Name Numerology Calculator',
          description: 'Discover the hidden meaning in your name through numbers and understand your personality traits and destiny'
        }
      },
      translateName: {
        title: 'Translate Your Name to Chinese',
        description: 'Translate foreign names into Chinese names with similar pronunciation, providing multiple options and detailed meaning explanations'
      },
      multilingualName: {
        title: 'Multilingual Name Translation',
        description: 'Support for name translation in multiple languages, including English, French, German, Spanish and more'
      },
      knowledge: {
        title: 'Chinese Name Knowledge',
        description: 'Learn about Chinese naming traditions, character meanings, pronunciation rules and cultural background'
      },
      zodiacCalculator: {
        title: 'Zodiac Calculator',
        description: 'Calculate your Chinese zodiac sign and learn about its characteristics and naming suggestions'
      },
      constellation: {
        title: 'Constellation Analysis',
        description: 'Analyze your constellation traits based on your birth date, providing detailed interpretation, personality analysis and naming suggestions'
      },
      nameAnalysis: {
        title: 'Name Analysis',
        description: 'Analyze the phonetics, character meanings, five elements and overall harmony of your Chinese name'
      }
    },
    categories: {
      translation: 'Name Translation Services',
      namingService: 'Personalized Naming Services',
      pinyinTools: 'Pinyin Conversion Tools',
      knowledge: 'Chinese Name Resources'
    },
    personalizedServices: {
      title: 'Personalized Naming Services',
      custom: {
        title: 'Custom Chinese Name',
        description: 'AI-powered personalized Chinese name creation based on your preferences'
      },
      zodiac: {
        title: 'Zodiac Calculator',
        description: 'Calculate your Chinese zodiac sign and learn about its characteristics and naming suggestions'
      },
      constellation: {
        title: 'Constellation Analysis',
        description: 'Analyze your constellation traits based on your birth date and get naming inspiration'
      },
      gender: {
        title: 'Gender Analysis',
        description: 'Explore naming options based on gender considerations and cultural preferences'
      }
    },
    knowledgeBase: {
      title: 'Chinese Name Knowledge Resources',
      description: 'Comprehensive guides and references for understanding Chinese naming traditions and practices'
    },
    about: {
      title: 'About Us',
      description: 'We are a professional team focused on Chinese name services, combining linguistics, cultural research and modern technology to provide high-quality Chinese name solutions for global users.',
      expertise: {
        title: 'Expert Team',
        description: 'Our team consists of linguists, cultural consultants, and technical developers with years of experience in researching Chinese naming traditions.'
      },
      quality: {
        title: 'Quality Service',
        description: 'We are committed to providing accurate, professional, and culturally meaningful Chinese name solutions to help every user find their perfect Chinese name.'
      },
      global: {
        title: 'Global Service',
        description: 'We serve users from around the world, offering personalized Chinese name creation and translation services that respect different cultural backgrounds and individual needs.'
      },
      team: {
        title: 'Our Team',
        description: 'We are a group of language and culture enthusiasts with deep knowledge of Chinese language and naming traditions, applying this expertise through technology to our service platform.'
      },
      contact: {
        title: 'Contact Us',
        description: 'If you have any questions, suggestions, or partnership inquiries, please feel free to contact us. We look forward to helping you!',
        button: 'Email Us'
      }
    }
  },
  translate: {
    title: 'Translate Your Name to Chinese',
    firstName: 'First Name',
    lastName: 'Last Name',
    fullName: 'Your Full Name',
    fullNamePlaceholder: 'Enter your full name...',
    gender: 'Gender',
    male: 'Male',
    female: 'Female',
    other: 'Other',
    translateButton: 'Translate',
    errors: {
      fullNameRequired: 'Please enter your full name'
    },
    results: {
      title: 'Translation Results',
      characters: 'Chinese Characters',
      pinyin: 'Pinyin',
      meaning: 'Meaning',
      cultural: 'Cultural Background',
      pronunciation: 'Pronunciation',
      alternatives: 'Alternative Options'
    }
  },
  custom: {
    title: 'Create Your Custom Chinese Name',
    preferences: 'Preferences',
    meaning: 'Desired Meaning',
    sound: 'Sound Preferences',
    characteristics: 'Personal Characteristics',
    birthdate: 'Birth Date and Time',
    generateButton: 'Generate Names',
    showMore: 'Show More Options',
    showLess: 'Show Less',
    playPronunciation: 'Play Pronunciation',
    results: {
      title: 'Custom Name Suggestions',
      explanation: 'Name Explanation',
      cultural: 'Cultural Background',
      save: 'Save This Name',
      birthInfo: 'Birth Information',
      nameAnalysis: 'Name Analysis'
    },
    nameAnalysis: {
      strokes: 'Strokes',
      fiveElements: 'Five Elements',
      soundMeaning: 'Sound & Meaning',
      compatibility: 'Compatibility with Birth Chart',
      score: 'Score'
    },
    birthInfo: {
      solarDate: 'Solar Date',
      lunarDate: 'Lunar Date',
      zodiac: 'Chinese Zodiac',
      eightChar: 'Eight Characters',
      fiveElements: 'Five Elements',
      naYin: 'Hidden Stem',
      year: 'Year',
      month: 'Month',
      day: 'Day',
      hour: 'Hour'
    }
  },
  multilingual: {
    title: 'Multilingual Name Translation',
    sourceLang: 'Source Language',
    targetLang: 'Target Language',
    name: 'Your Name',
    translateButton: 'Translate',
    results: {
      title: 'Translation Results',
      original: 'Original',
      translated: 'Translated',
      pronunciation: 'Pronunciation',
      alternatives: 'Alternatives'
    }
  },
  knowledge: {
    title: 'Chinese Name Knowledge Base',
    categories: {
      surnames: 'Chinese Surnames',
      naming: 'Naming Traditions',
      historical: 'Historical Names',
      regional: 'Regional Differences',
      taboos: 'Naming Taboos'
    },
    soundFormTaboos: {
      title: 'Sound and Form Taboos in Naming',
      subtitle: 'Avoiding characters that sound like or look like unlucky meanings or names of elders',
      sections: {
        intro: 'In Chinese culture, naming is a significant affair, and avoiding taboos in sound and form is a crucial aspect of the naming process.',
        soundTaboos: 'Sound Taboos',
        formTaboos: 'Form Taboos',
        combinationTaboos: 'Combined Sound and Form Taboos',
        modernConsiderations: 'Modern Considerations',
        practicalGuidelines: 'Practical Naming Guidelines'
      }
    },
    modernTraditional: {
      title: 'Balancing Tradition and Modernity',
      subtitle: 'Finding harmony between traditional cultural elements and modern aesthetics in naming',
      sections: {
        historicalEvolution: 'Historical Evolution of Naming Concepts',
        balancePrinciples: 'Principles for Balancing Tradition and Modernity',
        practicalExamples: 'Practical Examples of Combining Modern and Traditional Elements',
        practicalApproaches: 'Practical Strategies for Integration',
        futureTrends: 'Future Trends and Outlook'
      }
    },
    professionalConsiderations: {
      title: 'Professional and Social Role Considerations',
      subtitle: 'Name selection based on career aspirations and modern social roles',
      sections: {
        nameInfluence: 'Potential Influence of Names on Career Development',
        differentFields: 'Naming Considerations for Different Professional Fields',
        genderNeutrality: 'Gender Neutrality and Career Development',
        internationalContext: 'Naming Strategies in International Work Contexts',
        digitalAge: 'New Naming Considerations in the Digital Age'
      }
    }
  },
  chineseSurnames: {
    title: 'Chinese Surnames',
    intro: {
      title: 'Origins and Evolution of Chinese Surnames',
      content: 'Chinese surname culture has a long history and is one of the oldest and richest surname systems in the world. From the Xia, Shang, and Zhou dynasties to the present, Chinese surnames have undergone thousands of years of development and evolution, forming a distinctive cultural system.',
      imageCaption: 'Illustration of ancient Chinese surname culture'
    },
    distinction: {
      title: 'Difference Between Xing and Shi',
      content: 'In ancient China, "Xing" (姓) and "Shi" (氏) were originally two different concepts:',
      surname: 'Xing: Originally derived from matriarchal society, representing blood relationships, with women as the basis. Ancient characters with the "woman" radical were often surnames, such as Ji, Jiang, Yao, etc.',
      clan: 'Shi: Originated from patriarchal society, representing family, tribe, or enfeoffed territory, related to social status and occupation.',
      merge: 'After the Zhou Dynasty, Xing and Shi gradually merged, forming the concept of "surname" as we know it today.'
    },
    origins: {
      title: 'Main Sources of Chinese Surnames',
      intro: 'Chinese surnames were formed through various paths, mainly including the following sources:',
      totem: {
        title: '1. Derived from Totem Worship',
        content: 'In ancient times, tribes used their worshipped animals, plants, or natural objects as totems, which later evolved into surnames. For example:',
        examples: [
          'Xiong (Bear totem)',
          'Ma (Horse totem)',
          'Long (Dragon totem)'
        ]
      },
      ancestor: {
        title: '2. Derived from Ancestor Names',
        content: 'Using the name or title of ancestors as surnames for descendants. For example:',
        examples: [
          'Ji (Yellow Emperor was named Ji Xuanyuan, his descendants took Ji as their surname)',
          'Zhao, Qian, Sun, Li, etc. derived from ancestral names'
        ]
      },
      territory: {
        title: '3. Derived from Territories or State Names',
        content: 'Using the name of an enfeoffed territory or state as a surname. For example:',
        examples: [
          'Qi (derived from the State of Qi)',
          'Lu (derived from the State of Lu)',
          'Wei (derived from the State of Wei)'
        ]
      },
      official: {
        title: '4. Derived from Official Positions',
        content: 'Using the official positions held by ancestors as surnames. For example:',
        examples: [
          'Sima (official in charge of military affairs)',
          'Situ (official in charge of civilian affairs)',
          'Sikong (official in charge of engineering works)'
        ]
      },
      migration: {
        title: '5. Name Changes Due to Migration',
        content: 'Changing surnames due to war, political factors, or other reasons. For example:',
        examples: [
          'Descendants of the Li Tang imperial family changed to Zhao, Guo, etc. when seeking refuge',
          'During the late Han and Three Kingdoms period, some of Cao Cao\'s subordinates changed their surnames to avoid war'
        ]
      },
      minority: {
        title: '6. Sinicization of Ethnic Minorities',
        content: 'Adopting Han surnames after ethnic minorities integrated with the Han nationality. For example:',
        examples: [
          'Wanyan changed to Wang',
          'Aisin Gioro changed to Jin, Jin Xiao, etc.'
        ]
      }
    },
    distribution: {
      title: 'Distribution and Characteristics of Chinese Surnames',
      intro: 'Chinese surnames show a characteristic of "many people sharing common surnames, few with rare surnames." According to statistics, there are about 3,000 surnames in contemporary China, among which the most common surnames are:',
      topSurnames: [
        { rank: 1, name: 'Li', percentage: 'About 7.9% of the total population' },
        { rank: 2, name: 'Wang', percentage: 'About 7.4% of the total population' },
        { rank: 3, name: 'Zhang', percentage: 'About 7.1% of the total population' },
        { rank: 4, name: 'Liu', percentage: 'About 5.4% of the total population' },
        { rank: 5, name: 'Chen', percentage: 'About 4.5% of the total population' }
      ],
      conclusion: 'The top 100 common surnames cover about 85% of the Chinese population. This distribution pattern is closely related to factors such as population migration and political changes throughout Chinese history.'
    },
    significance: {
      title: 'Historical Significance of Surname Culture',
      intro: 'Surnames are not only family identifiers but also carry rich historical and cultural connotations:',
      points: [
        'Blood Bond: Surnames are symbols of blood relationships that maintain family cohesion',
        'Historical Witness: The rise and fall of different surnames reflect the historical changes in Chinese society',
        'Cultural Heritage: Family genealogies record family history and cultural traditions',
        'Regional Characteristics: Some surnames are highly concentrated in specific regions, forming unique regional cultures'
      ]
    },
    modern: {
      title: 'Surname Culture in Modern Society',
      intro: 'In contemporary society, surname culture continues to play an important role:',
      points: [
        'Inheritance of family concepts and the rise of genealogical research',
        'Popularization of root-seeking activities, strengthening cultural identity',
        'Surnames as an important component of personal identity',
        'Overseas Chinese maintain connections with their homeland through surnames'
      ],
      conclusion: 'With the development of society, surname culture is constantly innovating and developing. Surname research has become an important branch of cultural and historical research.'
    }
  },
  nameToPinyin: {
    title: 'Convert Chinese Name to Pinyin',
    chineseName: 'Chinese Name',
    convertButton: 'Convert to Pinyin',
    playFullName: 'Play Full Name Pronunciation',
    downloadMP3: 'Download MP3 Audio',
    results: {
      title: 'Pinyin Results',
      standard: 'Standard Pinyin',
      withTones: 'Pinyin with Tones',
      pronunciation: 'Pronunciation Guide'
    }
  },
  pinyinToName: {
    title: 'Convert Pinyin to Chinese Name',
    pinyin: 'Pinyin Input',
    gender: 'Gender Preference',
    convertButton: 'Find Characters',
    actions: {
      copyResults: 'Copy Results',
      copyName: 'Copy Name',
      newSearch: 'New Search',
      tryAgain: 'Try Again',
      share: 'Share'
    },
    results: {
      title: 'Character Options',
      found: '{count} characters found',
      character: 'Character',
      meaning: 'Meaning',
      popularity: 'Popularity',
      noResults: 'No characters found for this pinyin'
    },
    selected: {
      title: 'Selected Characters',
      finalize: 'Create Name'
    },
    finalName: {
      title: 'Your Created Name',
      meaning: 'Name Meaning'
    },
    errors: {
      noPinyin: 'Please enter pinyin',
      conversionFailed: 'Failed to convert pinyin to characters',
      noNameSelected: 'Please select characters first'
    },
    share: {
      title: 'My Chinese Name',
      text: 'I created this Chinese name:'
    },
    nameFinalized: 'Name saved successfully',
    noMeaningProvided: 'No meaning available'
  },
  zodiac: {
    title: 'Chinese Zodiac Calculator',
    birthYear: 'Birth Year',
    calculateButton: 'Calculate Zodiac',
    results: {
      title: 'Your Zodiac Result',
      personality: 'Personality Traits',
      compatibility: 'Compatibility',
      luckyNumbers: 'Lucky Numbers',
      luckyColors: 'Lucky Colors',
      element: 'Element',
      year: 'Year'
    }
  },
  zodiacNaming: {
    title: 'Zodiac-Based Naming',
    birthYear: 'Birth Year',
    surname: 'Surname',
    gender: 'Gender',
    male: 'Male',
    female: 'Female',
    generateButton: 'Generate Name Suggestions',
    results: {
      title: 'Zodiac-Based Name Suggestions',
      year: 'Year',
      element: 'Element',
      nameRecommendations: 'Recommended Names',
      namingTips: 'Naming Tips'
    }
  },
  constellation: {
    title: 'Constellation Analysis',
    subtitle: 'Explore your constellation traits and naming inspiration',
    birthDate: 'Birth Date',
    calculate: 'Calculate Constellation',
    results: {
      sign: 'Constellation',
      element: 'Element',
      traits: 'Personality Traits',
      strengths: 'Strengths',
      weaknesses: 'Weaknesses',
      compatibility: 'Best Match',
      namingTips: 'Naming Suggestions',
      famousPersons: 'Famous People',
      dateRange: 'Date Range',
      guardianStar: 'Guardian Star',
      symbolMeaning: 'Symbol Meaning',
      luckyColor: 'Lucky Color',
      luckyNumber: 'Lucky Number',
      luckyStone: 'Lucky Stone',
      luckyDay: 'Lucky Day',
      flower: 'Constellation Flower',
      flowerMeaning: 'Flower Meaning',
      flowerAndMeaning: 'Constellation Flower & Meaning',
      mythOrigin: 'Mythological Origin'
    },
    signs: {
      aries: 'Aries',
      taurus: 'Taurus',
      gemini: 'Gemini',
      cancer: 'Cancer',
      leo: 'Leo',
      virgo: 'Virgo',
      libra: 'Libra',
      scorpio: 'Scorpio',
      sagittarius: 'Sagittarius',
      capricorn: 'Capricorn',
      aquarius: 'Aquarius',
      pisces: 'Pisces'
    },
    elements: {
      fire: 'Fire',
      earth: 'Earth',
      air: 'Air',
      water: 'Water'
    }
  },
  nameAnalysis: {
    title: 'Chinese Name Analysis',
    name: 'Chinese Name',
    analyzeButton: 'Analyze',
    results: {
      title: 'Name Analysis Results',
      strokes: 'Stroke Count',
      fiveElements: 'Five Elements',
      soundMeaning: 'Sound and Meaning',
      surname: 'Surname Analysis',
      givenName: 'Given Name Analysis',
      compatibility: 'Compatibility with Birth Date'
    }
  },
  numerology: {
    title: 'Name Numerology Calculator',
    fullName: 'Full Name',
    fullNamePlaceholder: 'Enter your full name',
    selectSystem: 'Numerology System',
    pythagorean: 'Pythagorean',
    chaldean: 'Chaldean',
    calculateButton: 'Calculate Numerology',
    guideTitle: 'How to Use the Name Numerology Calculator',
    results: {
      title: 'Your Numerology Analysis',
      expressionNumber: 'Expression Number',
      soulUrgeNumber: 'Soul Urge Number',
      personalityNumber: 'Personality Number',
      meaningTitle: 'Number Meaning',
      traits: 'Key Traits',
      luckyColors: 'Lucky Colors',
      luckyGems: 'Lucky Gemstones',
      coreNumbers: 'Your Core Numbers',
      calculationDetails: 'Calculation Details',
      expressionCalculation: 'Expression Number Calculation',
      soulUrgeCalculation: 'Soul Urge Number Calculation',
      personalityCalculation: 'Personality Number Calculation',
      sum: 'Sum',
      reduction: 'Reduction'
    },
    guide: {
      title: 'Understanding Name Numerology',
      intro: 'Name numerology is the ancient practice of assigning numerical values to letters in your name to reveal insights about your personality, strengths, and life path. Numerology has been used for thousands of years across various cultures to help people understand themselves and their relationships better.',
      systems: {
        title: 'Numerology Systems',
        content: 'There are two primary numerology systems used around the world, each with their own unique approach to assigning values to letters and interpreting the resulting numbers:',
        pythagoreanDesc: 'The most widely used system, developed by Greek mathematician Pythagoras. It assigns numbers 1-9 to letters in a sequential pattern and is considered more modern and accessible.',
        chaldeanDesc: 'An ancient system originating from Babylon that assigns numbers 1-8 to letters based on their vibrational value. It is considered more accurate by traditional numerologists but more complex.'
      },
      coreNumbers: {
        title: 'Core Numbers in Numerology',
        content: 'Your name contains several key numerical values that reveal different aspects of your personality and life:',
        expressionDesc: 'Represents your overall potential, natural abilities, and life purpose. It is calculated using all the letters in your full name.',
        soulUrgeDesc: 'Reveals your inner desires, motivations, and what your heart truly yearns for. It is calculated using only the vowels in your name.',
        personalityDesc: 'Shows how others perceive you and how you present yourself to the world. It is calculated using only the consonants in your name.'
      },
      faq: {
        title: 'Frequently Asked Questions',
        q1: 'How accurate is numerology?',
        a1: 'Numerology is considered an interpretive art rather than an exact science. Many find that their numerology readings provide valuable insights into their personality and life path, while others view it as a fun tool for self-reflection. The accuracy often depends on personal beliefs and how the information resonates with you.',
        q2: 'Which numerology system is better, Pythagorean or Chaldean?',
        a2: 'Neither system is definitively "better" than the other. The Pythagorean system is more commonly used in the Western world and is generally easier to understand. The Chaldean system is considered by some traditional numerologists to be more accurate as it is based on vibrational frequencies rather than sequential ordering. We recommend trying both to see which resonates more with you.',
        q3: 'Do I use my birth name or current name for calculations?',
        a3: 'For the most comprehensive analysis, you can calculate the numerology for both your birth name and your current name if they differ. Your birth name reveals innate qualities and your original life path, while your current name reflects your evolving identity and the energies you now project.'
      }
    }
  },
  common: {
    loading: 'Loading',
    searching: 'Searching...',
    copy: 'Copy',
    share: 'Share',
    copied: 'Copied to clipboard',
    copyFailed: 'Failed to copy',
    generatingNames: 'Generating personalized Chinese names for you, please wait...',
    translatingName: 'Translating your name, please wait...',
    processing: 'Processing',
    success: 'Success',
    error: 'Error',
    retry: 'Retry',
    cancel: 'Cancel',
    confirm: 'Confirm',
    required: 'Required field',
    optional: 'Optional',
    search: 'Go',
    noResults: 'No results found'
  }
} 